@let blok = block();
<section WLTempBorder
         [attr.id]="blok.sectionId ? blok.sectionId : null"
         [ngClass]="['relative', baseClass, getOuterClasses()]"
         [ngStyle]="{
          '--hero-background': transformMobileImage() ? blok.backgroundImage?.filename ? 'url(' + ($safeNavigationMigration(blok.backgroundImage?.filename) | imageUrlTransformPipe : 992 : 0) + ')' : '' : blok.backgroundImage?.filename ? 'url(' + $safeNavigationMigration(blok.backgroundImage?.filename) + ')' : '',
          '--hero-background-tablet': 'url(' + (($safeNavigationMigration(blok.backgroundImageTablet?.filename) | firstPresentValue: ($safeNavigationMigration(blok.backgroundImage?.filename) | imageUrlTransformPipe : 1400 : 0) : $safeNavigationMigration(blok.backgroundImageDesktop?.filename))) + ')',
          '--hero-background-desktop': 'url(' + (($safeNavigationMigration(blok.backgroundImageDesktop?.filename) | firstPresentValue: $safeNavigationMigration(blok.backgroundImageTablet?.filename) : $safeNavigationMigration(blok.backgroundImage?.filename))) + ')',
         }"
         class="w-full">
    <div [ngClass]="getInnerClasses()" class="w-full h-full px-5 min-h-4">
        <div
            [ngClass]="blok.backgroundImage && blok.imageOverlay ? 'hero-gradient hero-gradient--' + blok.imageOverlayColor : 'hidden'"></div>
        <div class="relative z-10">
            @if (blok.limited) {
                <div WLTempBorder class="max-w-content-width mx-auto">
                    @for (child of blok.children; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
            } @else {
                @for (child of blok.children; track child['_uid']) {
                    <s1-cms-component [blok]="child" />
                }
            }
        </div>
    </div>
</section>
